import { render, staticRenderFns } from "./PortalForm.vue?vue&type=template&id=72129b0c"
import script from "./PortalForm.vue?vue&type=script&lang=js"
export * from "./PortalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports